module.exports = __webpack_public_path__ + "static/media/standardized_patient.4161bfc4.gif";